import { defineComponent as _defineComponent } from 'vue'
import { nextTick } from 'vue'

type ReasonExampleItem = {
  title: string
  description: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReasonExampleDialog',
  props: {
    value: { type: Boolean },
    items: null,
    aiGeneratedExample: null
  },
  emits: ["input", "select"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void
  (e: 'select', text: string): void
}), expose: any, slots: any, attrs: any }) {





function onOpened() {
  nextTick(() => {
    document
      .querySelectorAll('.reason-example-dialog__container')
      .forEach((el) => {
        ;(el as HTMLElement).scrollTop = 0
      })
  })
}

function onSelect(description: string) {
  emit('select', description.replace(/<br>/gi, '\n'))
  emit('input', false)
}

return { __sfc: true,emit, onOpened, onSelect }
}

})